<div class="badge badge-pill" [ngClass]="paid ? 'badge-success' : 'badge-danger'">
  <ng-container *ngIf="paid" i18n>Paid</ng-container>
  <ng-container *ngIf="!paid" i18n>Unpaid</ng-container>
</div>
